import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import "./searchabledropdown.css";
import uniqBy from "lodash/uniqBy";
import PropTypes from "prop-types";
/*istanbul ignore next */
export default function SearchableDropDown(props) {
  const { isEditMode } = props;
  const index = props.index ? props.index : 0;
  return (
    <Autocomplete
      clearIcon={props.clearIcon}
      disablePortal={!props.multiple}
      multiple={props.multiple}
      options={props.options}
      isOptionEqualToValue={(option, value) => option.value === value?.value}
      renderOption={(props, option) => {
        return (
          <li {...props} key={option.value}>
            {option.label}
          </li>
        );
      }}
      value={!props.multiple && props.value ? props.value[0] : props.value}
      onChange={(event, newValue) => {
        let values =
          props.multiple && props.value
            ? uniqBy(newValue, (obj) => obj.id)
            : newValue;
        props.setData(values, index);
      }}
      disabled={props.disabled}
      filterSelectedOptions
      id={props.id}
      className={
        !isEditMode
          ? `disable-searchable-dropdown  ${props.className} ${props?.classNameValue}`
          : `searchable-dropdown ${props.className}`
      }
      data-testid={props.id}
      sx={{ width: props.width }}
      renderInput={(params) => (
        <TextField {...params} placeholder={props.placeholder} />
      )}
    />
  );
}

SearchableDropDown.propTypes = {
  isEditMode: PropTypes.bool,
  showSelectAllOption: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  setData: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  id: PropTypes.string,
  clearIcon: PropTypes.node,
  disabled: PropTypes.bool,
  from: PropTypes.string,
  className: PropTypes.string,
  classNameValue: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  index: PropTypes.number,
  noOptionsMessage: PropTypes.string,
};
